import { render } from "./PaqueteCreate.vue?vue&type=template&id=248dc55c&scoped=true"
import script from "./PaqueteCreate.vue?vue&type=script&lang=js"
export * from "./PaqueteCreate.vue?vue&type=script&lang=js"

import "./PaqueteCreate.vue?vue&type=style&index=0&id=248dc55c&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\fronted_sit_bolivia\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-248dc55c"]])

export default __exports__